import { Box, Typography } from '@mui/material';
import ChatHeaderStatus from 'components/@home/@messages/ChatPanel/ChatHeader/ChatHeaderStatus';
import EmployeeAvatar from 'components/@home/EmployeeAvatar';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import currentChannel from 'store/selectors/currentChannel';
import DetailsButton from './DetailsButton';

const limitedCurrentChannel = createSelector(currentChannel, ({ name, description, avatar }) => ({
  name,
  description,
  avatar,
}));

const ChatHeader = () => {
  const { name, avatar, description } = useSelector(limitedCurrentChannel);
  return (
    <Box
      sx={theme => ({
        minHeight: 70,
        display: 'flex',
        justifyContent: 'space-between',
        padding: '13px 20px',
        margin: 0,
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
      })}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <EmployeeAvatar
          large
          employee={{
            name,
            avatar,
          }}
        />
        <Box sx={{ paddingLeft: '12px' }}>
          <Typography
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {name + (description ? ` - ${description}` : '')}
          </Typography>

          <ChatHeaderStatus />
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DetailsButton />
      </Box>
    </Box>
  );
};

export default memo(ChatHeader);
